import Component from './component';
import Swiper from 'swiper/dist/js/swiper.js';
import createComponentFactory from '../createComponent';

class PrimaryBannerSwipe extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this._sliderContext = null;
  }

  _bindEvents() {

  }

  _unbindEvents() {

  }

  didRegisterComponent() {

    this._sliderContext = new Swiper(this.element, {
      freeMode: true,
      slidesPerView: 'auto'
    });

    this._bindEvents();
  }

  didUnregisterComponent() {

    if(this._sliderContext) {
      this._sliderContext.destroy();
      this._sliderContext = null;
    }

    this._unbindEvents();
  }

}

export default createComponentFactory(PrimaryBannerSwipe);



// WEBPACK FOOTER //
// ./src/js/app/component/primaryBannerSwipe.js